import SEOHead from '../../utils/helpers/seo';

/**
 * Reusable SEO wrapper component to eliminate duplication across pages
 * Handles all SEO meta tags, OpenGraph, Twitter Cards, and structured data
 */
export const SEOWrapper = ({ pageData, configData, pageUrl, seoData }) => {
    const seoConfig = {
        title: pageData.seo?.metaTitle || seoData.title,
        description: pageData.seo?.metaDescription || seoData.description,
        canonical: pageData.seo?.canonicalURL || seoData.canonical,
        openGraph: {
            title: pageData.seo?.metaSocial?.[0]?.title || pageData.seo?.metaTitle || seoData.title,
            description: pageData.seo?.metaSocial?.[0]?.description || pageData.seo?.metaDescription || seoData.description,
            image: pageData.seo?.metaImage?.url || seoData.openGraph.images[0]?.url,
            type: 'website',
            url: pageData.seo?.canonicalURL || seoData.canonical,
        },
        twitter: {
            title: pageData.seo?.metaSocial?.[1]?.title || pageData.seo?.metaTitle || seoData.title,
            description: pageData.seo?.metaSocial?.[1]?.description || pageData.seo?.metaDescription || seoData.description,
            image: pageData.seo?.metaImage?.url || seoData.twitter.images,
        },
        structuredData: pageData.seo?.structuredData || seoData.structuredData,
    };

    return (
        <SEOHead 
            pageData={pageData}
            configData={configData}
            pageUrl={pageUrl}
            customSEO={seoConfig}
        />
    );
};

export default SEOWrapper;
